
class productPage {
  
  constructor(){
    this.init();
  }
  
  sizeChart = () => {
    document.addEventListener('click', (e) => {
      let sizeChartTabs = document.querySelectorAll('.size-chart-tab button');
      sizeChartTabs.forEach(btn =>{
        if(e.target == btn){
          sizeChartTabs.forEach(btns =>{btns.classList.remove('active');});
          e.target.classList.add('active');
          let targetEle = e.target.getAttribute('data-tab-trigger');
          let tabContent = document.querySelectorAll('.size-chart__inner .table-responsive');
          tabContent.forEach(content => {
            let tabId = content.getAttribute('id');
            if (targetEle == tabId) {
              content.classList.add('active');
            }else {
              content.classList.remove('active');
            }
          })
        }
      });
    });
    
    //trigger different sizechart
    let pInfoBtn = document.querySelector('.product-info-block.with-icon.text-box');
    if(pInfoBtn){
      document.addEventListener('click', (e)=> {
        if (e.target == pInfoBtn || pInfoBtn.contains(e.target)) {
          console.log(e.target);
          let triggerBtn = document.querySelector('.size-chart-link');  
          triggerBtn.dispatchEvent(new Event('click'));
        }
      })
    }
  }
  
  metafieldVariantData = () => {
    let optSelector = document.querySelectorAll('.opt-name');
    let metaOpts = document.querySelectorAll('#custMetaDimantion li');
    let metaLabel = document.querySelector('#custMetaDimantion label');
    optSelector.forEach(btn => {
      btn.addEventListener('click', ()=> {
        setTimeout( ()=> {
          let currentVarId = document.querySelector(`select[name="id"]`).value;
          let cacheCount = 0;
          metaOpts.forEach(opts => {
            let optId = opts.getAttribute('id');
            if(optId == currentVarId){
              opts.style.display = 'block';
              cacheCount = 1;
              metaLabel.style.display = 'block';
            } else {
              if (cacheCount != 1) {
                metaLabel.style.display = 'none';
              }
              opts.style.display = 'none';
            }
          });
          cacheCount = 0;
        },200)
      })
    });
    
    let selectedVal = document.querySelector('.opt-btn[checked]+label');
	if(selectedVal){
    	selectedVal.dispatchEvent(new Event('click'));
    }
  }
  
  init(){
    this.sizeChart();
    this.metafieldVariantData();
  } 
}

new productPage;

